import { useState } from "react";
import { feedTabs, flashFeed } from "@/mocks/home";

export default function FlashFeed() {
  const [active, setActive] = useState("全部");

  const items = active === "全部" ? flashFeed : flashFeed.filter((item) => item.tag === active);

  return (
    <section id="feed" className="border-b border-background-200">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
              Flash Feed
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日快讯流
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">
              按时间倒序滚动的短讯记录，只留标题和一句话摘要。没有明确信源的都标成待核，
              看到不确定的内容先别急着下结论。
            </p>
          </div>
          <div className="flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-100 p-1">
            {feedTabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                  active === tab
                    ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 divide-y divide-background-200 border-y border-background-200">
          {items.map((item) => (
            <article key={item.id} className="group flex gap-4 py-5 md:gap-6">
              <div className="flex w-12 shrink-0 flex-col items-center pt-0.5 md:w-16">
                <span className="font-heading text-base font-bold tabular-nums text-foreground-900 md:text-lg">
                  {item.time}
                </span>
                <span className="mt-1 hidden text-[10px] text-foreground-400 md:block">今日</span>
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`rounded-sm px-2 py-0.5 text-[11px] font-medium ${
                      item.tag === "爆料"
                        ? "bg-primary-100 text-primary-800"
                        : item.tag === "回应"
                          ? "bg-secondary-100 text-secondary-800"
                          : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="flex items-center gap-1 text-[11px] font-medium text-accent-800">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-fire-fill"></i>
                      </span>
                      热
                    </span>
                  )}
                </div>

                <h3 className="mt-2 text-sm font-bold leading-6 text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs leading-6 text-foreground-500 md:text-sm">
                  {item.summary}
                </p>

                <div className="mt-3 flex items-center gap-4 text-[11px] text-foreground-500">
                  <a href="#comments" className="flex cursor-pointer items-center gap-1 hover:text-primary-600">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-chat-3-line"></i>
                    </span>
                    {item.comments} 条讨论
                  </a>
                  <span className="flex items-center gap-1">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-shield-check-line"></i>
                    </span>
                    待核实来源
                  </span>
                </div>
              </div>
            </article>
          ))}
          {items.length === 0 && (
            <div className="py-16 text-center text-sm text-foreground-500">
              这个标签下暂时没有快讯，换个标签看看~
            </div>
          )}
        </div>
      </div>
    </section>
  );
}